export const authenticationRoutes = {
  login: "login",
  logout: "logout",
  verifyEmail: "verify-email",
  multiFactorAuthentication: "mfa",
  forgotPassword: "forgot-password",
  resetPassword: "reset-password",
  magicLinkSent: "magic-link-sent",
  magicLink: "magic-link",
  magicLinkEnterCode: "magic-link-enter-code",
  oauth: "oauth",
} as const;
